import { UserProfileModel } from './../../models/userProfileModel';
import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { State } from '../store';
import { loadProfile } from '../store/profile/profile.actions';
import { AppPermission } from 'src/app/models/appEnums';
import { take } from 'rxjs';

@Injectable()
export class AuthGuard  {

  constructor(
    private router: Router,
    private store: Store<State>,) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (localStorage.getItem('currentUser')) {
      let profile: UserProfileModel;
      this.store.dispatch(loadProfile());
      this.store.select(s => s.profileState.profile).subscribe(p => {
        profile = p;
      });

      if (profile) {
        if (profile.employee != null && profile.employee.terminationDate != null) {
          return false;
        }
        if (profile.isOnBoarding) {
          const url = state.url.split('?')[0];
          const benefitsRoute = /^\/benefits-enrollment\/(enrollment|dependents|docs\/list|docs\/sign\/\d+|sign\/\d+)$/.test(url);
          const benefitsProfile = url === '/profile' && route.queryParamMap.get('backTo') === '/benefits-enrollment/enrollment';
          if (benefitsRoute || benefitsProfile) {
            let hasBenefitsAccess = false;
            this.store.select(s => s.accountState.user?.permissionIDs).pipe(take(1)).subscribe(ids => {
              hasBenefitsAccess = !!ids?.includes(AppPermission.BenefitsAccess);
            });
            return hasBenefitsAccess;
          }
          if (url !== '/onboarding' && url !== '/' && !url.startsWith('/onboarding/')) {
            return false;
          }
          return true;
        }
      }

      // logged in so return true
      return true;
    }

    // not logged in so redirect to login page with the return url
    if (state.url) {
      this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    } else {
      this.router.navigate(['/login']);
    }
    return false;
  }
}
